import React, { useState, useEffect } from "react";
import { collection, addDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "../FirebaseComp/firebase";
import emailjs from "emailjs-com";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import "./booking.css";

const Notification = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`notification ${type}`} onClick={onClose}>
      <div className="notification-content">
        <span className="notification-message">{message}</span>
        <button className="notification-close">×</button>
      </div>
    </div>
  );
};

function Booking() {

  const [greeting, setGreeting] = useState("");
  const [step, setStep] = useState(1);
  const [patientType, setPatientType] = useState("");
  const [reasonForVisit, setReasonForVisit] = useState("");
  const [appointmentDate, setAppointmentDate] = useState("");
  const [appointmentTime, setAppointmentTime] = useState("");
  const [timeSlots, setTimeSlots] = useState([]);
  const [reservedSlots, setReservedSlots] = useState([]);
  const [notification, setNotification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  // Patient Information
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [insuranceName, setInsuranceName] = useState("");
  const [primaryMemberName, setPrimaryMemberName] = useState("");
  const [comments, setComments] = useState("");

  const currentDate = new Date();
  const reasonOptions = [
"Ayurvedic Full Body Massage - 90min",
"Ayurvedic Full Body Massage - 60min",
"Head, Neck & Shoulder Massage - 60min",
"Sinus Relief - 45min",
"Stress Relief - 45min",
"Foot Reflexology - 60min",
"Steam Bath / Steam Box Therapy - 15min",
"Herbal Bath - 30min",
"Shirodhara - 45min",
"Full Body Scrub - 45min",
  ];

  // Set greeting based on time
  useEffect(() => {
    const hours = new Date().getHours();
    if (hours < 12) setGreeting("Good Morning");
    else if (hours < 18) setGreeting("Good Afternoon");
    else setGreeting("Good Evening");
  }, []);

 // Generate time slots from 8 AM to 8 PM with 90-minute intervals
useEffect(() => {
  const slots = [];
  const start = new Date();
  start.setHours(8, 0, 0, 0); // Start at 8:00 AM
  const end = new Date();
  end.setHours(20, 0, 0, 0); // End at 8:00 PM

  let currentSlot = new Date(start);
  
  while (currentSlot < end) {
    const slotStart = new Date(currentSlot);
    const slotEnd = new Date(currentSlot);
    slotEnd.setMinutes(slotEnd.getMinutes() + 90);
    
    // Only add if end time doesn't exceed 8 PM
    if (slotEnd <= end) {
      const timeString = `${slotStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${slotEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
      slots.push(timeString);
    }
    
    currentSlot.setMinutes(currentSlot.getMinutes() + 90); // Add 90 minutes for next slot
  }
  
  setTimeSlots(slots);
}, []);

// Fetch reserved slots for selected date
useEffect(() => {
  const fetchReservedSlots = async () => {
    if (!appointmentDate) return;
    try {
      const q = query(collection(db, "onlinebookings"), where("date", "==", appointmentDate));
      const querySnapshot = await getDocs(q);
      const slots = querySnapshot.docs.map((doc) => doc.data().time);
      setReservedSlots(slots);
    } catch (err) {
      setNotification({ message: "Failed to fetch reserved slots.", type: "error" });
    }
  };
  fetchReservedSlots();
}, [appointmentDate]);









  const handlePatientTypeSelect = (type) => {
    setPatientType(type);
    setStep(2);
  };

  const handleReasonSelect = (reason) => {
    setReasonForVisit(reason);
  };

  const handleDateChange = (e) => {
    const selected = e.target.value;
    if (selected < currentDate.toISOString().split("T")[0]) {
      setNotification({ message: "Please select today or future date.", type: "error" });
      return;
    }
    setAppointmentDate(selected);
    setAppointmentTime(""); // Reset time when date changes
  };

  const handleTimeSelection = (time) => {
    if (reservedSlots.includes(time)) {
      setNotification({ message: "This time slot is already booked.", type: "error" });
      return;
    }
    setAppointmentTime(time);
  };

  const validateStep2 = () => {
    if (!reasonForVisit) {
      setNotification({ message: "Please select a reason for visit.", type: "error" });
      return false;
    }
    if (!appointmentDate) {
      setNotification({ message: "Please select a date.", type: "error" });
      return false;
    }
    if (!appointmentTime) {
      setNotification({ message: "Please select a time.", type: "error" });
      return false;
    }
    return true;
  };

  const handleNextToStep3 = () => {
    if (validateStep2()) {
      setStep(3);
    }
  };

  const validateStep3 = () => {
    if (!firstName || !lastName) {
      setNotification({ message: "Please enter first and last name.", type: "error" });
      return false;
    }
   
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setNotification({ message: "Please enter a valid email address.", type: "error" });
      return false;
    }
    if (!phoneNumber || !/^\+\d{10,15}$/.test(phoneNumber)) {
      setNotification({ 
        message: "Please enter a valid phone number with country code.", 
        type: "error" 
      });
      return false;
    }
    return true;
  };

  const handleSubmitRequest = async () => {
    if (!validateStep3()) return;

    setIsLoading(true);
    try {
      // Save to Firebase
      await addDoc(collection(db, "onlinebookings"), {
        patientType,
        reasonForVisit,
        date: appointmentDate,
        time: appointmentTime,
        firstName,
        lastName,
        email,
        phone: phoneNumber,
        comments,
        location: "-",
        createdAt: new Date(),
      });



      // Send confirmation email
        await emailjs.send(
          "service_5x2anhk",
          "template_galafu4",
          {
            firstName,
            lastName,
            reasonForVisit,
            appointmentDate: new Date(appointmentDate).toLocaleDateString('en-US', { 
              weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' 
            }),
            appointmentTime,
            phoneNumber,
            email,
            comments,
            patientType: patientType === "new" ? "New Customer" : "Returning Customer"
          },
          "d8MPSVybGHqsEvNou"
        );




      setNotification({ 
        message: "Your Booking request submitted successfully", 
        type: "success" 
      });
      
      // Reset form after successful submission
      setTimeout(() => {
        setStep(1);
        setPatientType("");
        setReasonForVisit("");
        setAppointmentDate("");
        setAppointmentTime("");
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhoneNumber("");
        setComments("");
      }, 3000);

    } catch (err) {
      console.error("Error requesting the booking:", err);
      setNotification({ 
        message: "Error requesting the booking. Please try again.", 
        type: "error" 
      });
    } finally {
      setIsLoading(false);
    }
  };

  const renderTimeSlots = () => {
    const availableSlots = timeSlots.filter(slot => !reservedSlots.includes(slot));
    const bookedSlots = timeSlots.filter(slot => reservedSlots.includes(slot));

    return (

      <>
      


    








        {availableSlots.length > 0 && (
          <div className="time-slots-section">
            <h4 className="time-slots-title">Available Slots</h4>
            <div className="time-slots-grid">
              {availableSlots.map((slot, i) => {
                const [h, m] = slot.split(":").map(Number);
                const slotTime = new Date();
                slotTime.setHours(h, m, 0, 0);
                const isPast = appointmentDate === currentDate.toISOString().split("T")[0] && slotTime < currentDate;
                const isSelected = appointmentTime === slot;

                return (
                  <button
                    key={i}
                    onClick={() => !isPast && handleTimeSelection(slot)}
                    disabled={isPast}
                    className={`time-slot-btn ${isPast ? "past" : ""} ${isSelected ? "selected" : ""}`}
                  >
                    {slot}
                  </button>
                );
              })}
            </div>
          </div>
        )}

        {bookedSlots.length > 0 && (
          <div className="time-slots-section">
            <h4 className="time-slots-title booked">Booked Slots</h4>
            <div className="time-slots-grid">
              {bookedSlots.map((slot, i) => (
                <button
                  key={i}
                  disabled
                  className="time-slot-btn booked"
                >
                  {slot}
                  <span className="booked-badge">Booked</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </>
    );
  };

  return (

    <>
    
          {/* Hero Section with banner.png from public folder - USING INLINE STYLE WITH PUBLIC PATH */}
      <section 
        className="treatments-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(46,125,50,0.9), rgba(0,0,0,0.7)), url('/footer banner.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
<h1 className="hero-title">
  Book Your Exclusive<br />
  <span>Natural Balance</span> Experience
</h1>

        </div>
      </section>

    <div className="booking-container">






      <div className="booking-card">
        {/* Header with Greeting */}
        <div className="header-section">
          <div className="header-content">
            <h1 className="greeting">{greeting}!</h1>
            <h2 className="title">Request An Booking</h2>
            <div className="clinic-info">
              <p className="location">Elysian Wellness</p>
              <p className="address">No. 31, Buduruwagala, Wellawaya, Sri Lanka</p>
              <p className="provider">070 554 9750</p>
            </div>
          </div>
        </div>

        {/* Step Indicators */}
        <div className="steps-container">
          <div className="step-indicator">
            <div className={`step-item ${step >= 1 ? "active" : ""} ${step > 1 ? "completed" : ""}`}>
              <div className="step-circle">
                {step > 1 ? "✓" : "1"}
              </div>
              <span className="step-label">Patient Type</span>
            </div>
            <div className={`step-line ${step >= 2 ? "active" : ""}`}></div>
            <div className={`step-item ${step >= 2 ? "active" : ""} ${step > 2 ? "completed" : ""}`}>
              <div className="step-circle">
                {step > 2 ? "✓" : "2"}
              </div>
              <span className="step-label">Appointment</span>
            </div>
            <div className={`step-line ${step >= 3 ? "active" : ""}`}></div>
            <div className={`step-item ${step >= 3 ? "active" : ""}`}>
              <div className="step-circle">3</div>
              <span className="step-label">Information</span>
            </div>
          </div>
        </div>

        {/* Step 1: Patient Type Selection */}
        {step === 1 && (
          <div className="step-content">
            <h3 className="step-title">Are you a new or returning Customer?</h3>
            <div className="patient-type-options">
              <button 
                className={`patient-type-card ${patientType === "new" ? "selected" : ""}`}
                onClick={() => handlePatientTypeSelect("new")}
              >
                <div className="card-icon">🆕</div>
                <div className="card-content">
                  <h4>New Customer</h4>
                  <p>First time visiting us</p>
                </div>
                <div className="card-arrow">→</div>
              </button>
              <button 
                className={`patient-type-card ${patientType === "returning" ? "selected" : ""}`}
                onClick={() => handlePatientTypeSelect("returning")}
              >
                <div className="card-icon">🔄</div>
                <div className="card-content">
                  <h4>Returning Customer</h4>
                  <p>Been here before</p>
                </div>
                <div className="card-arrow">→</div>
              </button>
            </div>
          </div>
        )}

        {/* Step 2: Appointment Details */}
        {step === 2 && (
          <div className="step-content">
            <h3 className="step-title">Select Appointment Details</h3>
            
            <div className="form-section">
              <div className="form-group">
                <label className="form-label">
                  <span className="label-text">Treatments</span>
                  <span className="required">*</span>
                </label>
                <select 
                  value={reasonForVisit} 
                  onChange={(e) => handleReasonSelect(e.target.value)}
                  className="form-select"
                >
                  <option value="">Select a Treatment</option>
                  {reasonOptions.map((reason) => (
                    <option key={reason} value={reason}>{reason}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">
                  <span className="label-text">Select Date</span>
                  <span className="required">*</span>
                </label>
                <input 
                  type="date" 
                  min={currentDate.toISOString().split("T")[0]} 
                  onChange={handleDateChange}
                  value={appointmentDate}
                  className="form-input"
                />
              </div>

              {appointmentDate && (
                <div className="form-group">
                  <label className="form-label">
                    <span className="label-text">Available Time Slots</span>
                    <span className="required">*</span>
                  </label>
                  <div className="time-slots-wrapper">
                    {renderTimeSlots()}
                  </div>
                </div>
              )}
            </div>

            <div className="navigation-buttons">
              <button className="btn-secondary" onClick={() => setStep(1)}>
                ← Back
              </button>
              <button 
                className="btn-primary" 
                onClick={handleNextToStep3}
                disabled={!reasonForVisit || !appointmentDate || !appointmentTime}
              >
                Continue →
              </button>
            </div>
          </div>
        )}

        {/* Step 3: Patient Information */}
        {step === 3 && (
          <div className="step-content">
            <h3 className="step-title">Customer Information</h3>
            
            <div className="appointment-summary-card">
              <h4>Appointment Summary</h4>
              <div className="summary-details">
                <div className="summary-row">
                  <span className="summary-label">Location:</span>
                  <span className="summary-value">Elysian Wellness</span>
                </div>
                <div className="summary-row">
                  <span className="summary-label">Address:</span>
                  <span className="summary-value">No. 31, buduruwagala, wellawaya, Srilanka</span>
                </div>
                <div className="summary-row">
                  <span className="summary-label">Contact No:</span>
                  <span className="summary-value">070 554 9750</span>
                </div>
                <div className="summary-row">
                  <span className="summary-label">Treatment:</span>
                  <span className="summary-value">{reasonForVisit}</span>
                </div>
                <div className="summary-row">
                  <span className="summary-label">Date & Time:</span>
                  <span className="summary-value">
                    {new Date(appointmentDate).toLocaleDateString('en-US', { 
                      weekday: 'long', 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })} at {appointmentTime}
                  </span>
                </div>
              </div>
            </div>

            <div className="patient-form">
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">
                    <span className="label-text">First Name</span>
                    <span className="required">*</span>
                  </label>
                  <input 
                    type="text" 
                    value={firstName} 
                    onChange={(e) => setFirstName(e.target.value)}
                    className="form-input"
                    placeholder="John"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">
                    <span className="label-text">Last Name</span>
                    <span className="required">*</span>
                  </label>
                  <input 
                    type="text" 
                    value={lastName} 
                    onChange={(e) => setLastName(e.target.value)}
                    className="form-input"
                    placeholder="Doe"
                  />
                </div>
              </div>


              <div className="form-group">
                <label className="form-label">
                  <span className="label-text">Email</span>
                  <span className="required">*</span>
                </label>
                <input 
                  type="email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  placeholder="email@example.com"
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  <span className="label-text">Phone Number</span>
                  <span className="required">*</span>
                </label>
                <PhoneInput
                  placeholder="+94 77 567 8900"
                  value={phoneNumber}
                  onChange={setPhoneNumber}
                  className="phone-input"
                />
              </div>



              <div className="form-group">
                <label className="form-label">
                  <span className="label-text">Comments</span>
                </label>
                <textarea 
                  value={comments} 
                  onChange={(e) => setComments(e.target.value)}
                  className="form-textarea"
                  placeholder="Additional notes (optional)"
                  rows="3"
                />
                <small className="form-note">
                Thank You for Choosing Us !!!
                </small>
              </div>
            </div>

            <div className="navigation-buttons">
              <button className="btn-secondary" onClick={() => setStep(2)}>
                ← Back
              </button>
              <button 
                className="btn-primary submit-btn" 
                onClick={handleSubmitRequest}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="loading-spinner"></span>
                    Requesting...
                  </>
                ) : (
                  'Request Booking'
                )}
              </button>
            </div>
          </div>
        )}

        {notification && (
          <Notification 
            message={notification.message} 
            type={notification.type} 
            onClose={() => setNotification(null)} 
          />
        )}
      </div>
    </div>
    </>

);
}



export default Booking